import { useTranslation } from "react-i18next";

import { HTML } from "@aviary";
import { l } from "@emerson/locales";

import { GenericCollapsible } from "../GenericCollapsible/GenericCollapsible";

interface Props {
  shortDescription: string;
  isDefaultExpanded?: boolean;
}

const Description = ({ shortDescription, isDefaultExpanded = false }: Props) => {
  const { t } = useTranslation();

  if (!shortDescription) return null;

  return (
    <GenericCollapsible
      header={t(l.productDetails.Description)}
      isDefaultExpanded={isDefaultExpanded}
    >
      {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
      <HTML dangerouslySetInnerHTML={{ __html: shortDescription }} />
    </GenericCollapsible>
  );
};

export { Description };
